import { ReactElement } from 'react';
import { Grid, useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import { ResearchFormIcaro } from 'civil-status/view-models/research-form-icaro';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import ListStatesDeclarations from '../../list/list-states-declaration';
import { SelectChangeEvent } from '@mui/material';
import ListHospital from '../../list/list-hospital';

const FormFilter = (): ReactElement => {
  const formContext = useFormikContext<ResearchFormIcaro>();

  const onChangeListStatesDeclarations = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('state', event.target.value);
  });

  const onChangeHospital = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('hospital', event.target.value);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <ListHospital
          onChange={onChangeHospital}
          value={formContext.values?.hospital || ''}
          error={formContext.touched?.hospital && Boolean(formContext.errors?.hospital)}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Anno dichiarazione"
          aria-label="Anno dichiarazione"
          id="year"
          fullWidth
          inputProps={{
            maxLength: '4',
          }}
          onChange={(event) => {
            formContext.setFieldValue('year', event.target.value);
          }}
          value={formContext.values?.year || ''}
          helperText={formContext.errors?.year}
          error={formContext.touched?.year && Boolean(formContext.errors?.year)}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Numero dichiarazione"
          aria-label="Numero dichiarazione"
          id="number"
          fullWidth
          onChange={(event) => {
            formContext.setFieldValue('number', event.target.value);
          }}
          value={formContext.values?.number || ''}
          helperText={formContext.errors?.number}
          error={formContext.touched?.number && Boolean(formContext.errors?.number)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data dichiarazione da"
          aria-label="Data dichiarazione da"
          value={formContext.values?.dateDeclarationStart || null}
          onChange={(date) => {
            formContext.setFieldValue('dateDeclarationStart', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateDeclarationStart"
              fullWidth
              error={
                formContext.touched?.dateDeclarationStart &&
                Boolean(formContext.errors?.dateDeclarationStart)
              }
              helperText={formContext.errors?.dateDeclarationStart}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data dichiarazione a"
          aria-label="Data dichiarazione a"
          value={formContext.values?.dateDeclarationEnd || null}
          onChange={(date) => {
            formContext.setFieldValue('dateDeclarationEnd', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateDeclarationEnd"
              fullWidth
              error={
                formContext.touched?.dateDeclarationEnd &&
                Boolean(formContext.errors?.dateDeclarationEnd)
              }
              helperText={formContext.errors?.dateDeclarationEnd}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ListStatesDeclarations
          onChange={onChangeListStatesDeclarations}
          value={formContext.values?.state || ''}
          error={formContext.touched?.state && Boolean(formContext.errors?.state)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Numero atto"
          aria-label="Numero atto"
          id="numberAct"
          fullWidth
          onChange={(event) => {
            formContext.setFieldValue('numberAct', event.target.value);
          }}
          value={formContext.values?.numberAct || ''}
          helperText={formContext.errors?.numberAct}
          error={formContext.touched?.numberAct && Boolean(formContext.errors?.numberAct)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data operazione da"
          aria-label="Data operazione da"
          value={formContext.values?.dateOperationStart || null}
          onChange={(date) => {
            formContext.setFieldValue('dateOperationStart', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateOperationStart"
              fullWidth
              error={
                formContext.touched?.dateOperationStart &&
                Boolean(formContext.errors?.dateOperationStart)
              }
              helperText={formContext.errors?.dateOperationStart}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data operazione a"
          aria-label="Data operazione a"
          value={formContext.values?.dateOperationEnd || null}
          onChange={(date) => {
            formContext.setFieldValue('dateOperationEnd', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateOperationEnd"
              fullWidth
              error={
                formContext.touched?.dateOperationEnd &&
                Boolean(formContext.errors?.dateOperationEnd)
              }
              helperText={formContext.errors?.dateOperationEnd}
            />
          )}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="space-between" display="flex">
        <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
          <Grid item xs={12} md={2}>
            <PmiButton
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => formContext.resetForm()}
            >
              Pulisci
            </PmiButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <PmiButton variant="contained" color="secondary" fullWidth type="submit">
              Cerca
            </PmiButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Filter Icaro Page - Act - Form component';

export default FormFilter;
